import { Ago } from '#components/Ago.js'
import './Footer.css'

const CopyrightYear = () => {
	const currentYear = new Date().getFullYear()

	return <>{currentYear}</>
}

export const Footer = () => (
	<footer>
		<main>
			<span class="copyright">
				© <CopyrightYear /> Nordic Semiconductor. All rights reserved.
			</span>
			<nav>
				<a
					target="_blank"
					href="https://docs.nordicsemi.com/bundle/nrf-cloud/page/index.html/"
				>
					Documentation
				</a>
				<a target="_blank" href="https://devzone.nordicsemi.com/">
					Support
				</a>
				<a target="_blank" href="https://www.nordicsemi.com/Privacy">
					Privacy Policy
				</a>
				<a target="_blank" href="https://nrfcloud.com/tos.pdf">
					Terms
				</a>
				<a target="_blank" href="https://status.nrfcloud.com/">
					Status
				</a>
			</nav>
		</main>
		<aside class="appInfo">
			<span>{VERSION}</span>
			<span>
				Proto: Account&nbsp;
				{ACCOUNT_PROTO_VERSION}
			</span>
			<span>
				built <Ago date={new Date(BUILD_TIME)} key={BUILD_TIME} /> ago
			</span>
		</aside>
	</footer>
)
